import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';

import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { InputIntegerModule } from '@sdbn/tmc-common';
import { StructureNodeSelectionModule } from '../../../components/structure-node-selection/structure-node-selection.module';
import { ReportFilterDetailsDialogComponent } from './component/report-filter-details-dialog.component';
import { ReportFilterComponent } from './component/report-filter.component';
import { MatRadioModule as MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatChipsModule as MatChipsModule } from '@angular/material/chips';

@NgModule({
  declarations: [
    ReportFilterComponent,
    ReportFilterDetailsDialogComponent
  ],
  imports: [
    CommonModule,
    CommonTranslationModule,
    CommonUIModule,

    MatTableModule,
    MatSortModule,
    ReactiveFormsModule,
    FormsModule,
    StructureNodeSelectionModule,
    InputIntegerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSelectModule,
    MatFormFieldModule,
    MatChipsModule
  ],
  exports: [
    ReportFilterComponent,
  ]
})
export class ReportFilterModule { }
